import { createTheme } from "@mui/material/styles";
import { FONT_TEXT, COLOR, LAYOUT } from "./designSystem";

/**
 * Styles-level theme — kept in sync with /src/theme.js.
 * Use this when importing from within /styles/.
 */
const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: COLOR.brand },
    background: {
      default: COLOR.bg0,
      paper: COLOR.bg1,
    },
    text: {
      primary: COLOR.textPrimary,
      secondary: COLOR.textSecondary,
    },
    success: { main: COLOR.success },
    error: { main: COLOR.error },
  },
  typography: {
    fontFamily: FONT_TEXT,
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiAlert: {
      styleOverrides: {
        root: {
          backgroundColor: COLOR.bg2,
          color: COLOR.textPrimary,
          border: `1px solid ${COLOR.border}`,
          borderRadius: LAYOUT.borderRadius.sm,
        },
        filledSuccess: { backgroundColor: "#064e3b", color: "#ecfdf5" },
        filledError: { backgroundColor: "#450a0a", color: "#fef2f2" },
      },
    },
  },
});

export default theme;
